import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'skeleton-engine',
  templateUrl: './skeleton-engine.component.html',
  styleUrls: ['./skeleton-engine.component.scss']
})
export class SkeletonEngineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
